import { ErrorCode } from "~/utils/enums/errors.enums";

export const MULTI_DAY_TIMESLOT_MESSAGE = "Impossible de créer une étape de plus d'un jour";

export function isMultiDayTimeslotError(error: unknown): boolean {
  return (error as { message?: unknown } | null)?.message === ErrorCode.MULTI_DAY_TIMESLOT_NOT_ALLOWED;
}
